module.exports = __webpack_public_path__ + "static/per-marker-customisation-8c800df9372b59798e5e9b03891d14f9.png";